document.addEventListener("DOMContentLoaded", function () {

    // Si el usuario ya cerró el popup
    if (localStorage.getItem("gl_intl_popup_closed") === "1") {
        return;
    }

    // Obtener país detectado por Shopify
    const country = (window.GL_COUNTRY || "").toUpperCase();

    // Solo mostrar si está en Perú
    if (country !== "PE") {
        return;
    }

    const overlay = document.getElementById("gl-intl-overlay");

    if (!overlay) return;

    // Mostrar popup
    overlay.style.display = "flex";

    // Botón ir a tienda Perú
    const btn = document.getElementById("gl-go-peru");

    if (btn) {

        btn.addEventListener("click", function () {

            localStorage.setItem("gl_intl_popup_closed", "1");

            window.location.assign(
                "https://ghiamlopez.com" +
                window.location.pathname +
                window.location.search
            );

        });

    }

});

// Cerrar popup
document.addEventListener("click", function (e) {

    if (
        e.target.id === "gl-intl-close" ||
        e.target.id === "gl-intl-stay"
    ) {

        localStorage.setItem("gl_intl_popup_closed", "1");

        const overlay = document.getElementById("gl-intl-overlay");

        if (overlay) {
            overlay.style.display = "none";
        }

    }

});